var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('CButton',{staticClass:"ml-1",attrs:{"size":"sm","color":"warning"},on:{"click":_vm.resetCountDown}},[_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.countDown)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }